// @ts-nocheck

export const localeCodes =  [
  "ar",
  "en"
]
export const localeLoaders = {
  ar: [
    {
      key: "locale_ar_46js_4727bbe9",
      load: () => import("#nuxt-i18n/4727bbe9" /* webpackChunkName: "locale_ar_46js_4727bbe9" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46js_5175234b",
      load: () => import("#nuxt-i18n/5175234b" /* webpackChunkName: "locale_en_46js_5175234b" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/437803cb" /* webpackChunkName: "config_i18n_46config_46ts_437803cb" */)
]
export const normalizedLocales = [
  {
    code: "ar",
    language: "ar-SA",
    name: "Arabic",
    dir: "rtl"
  },
  {
    code: "en",
    language: "en-US",
    name: "English",
    dir: "ltr"
  }
]

